import { mapGetters } from 'vuex';
import validation from "./validation"

export default {
    mixins: [validation],
    data: () => ({
        saving: false
    }),
    computed: {
        ...mapGetters({
            unsavedData: 'unsavedData'
        }),
    },
    watch: {
        form: {
            handler(value) {
                this.$store.dispatch('setUnsavedData', true)
            },
            deep: true
        }
    },
    beforeRouteLeave(to, from, next) {

        if (this.unsavedData) {
            var confirmed = confirm('Are you sure want to navigate to another tab? You have unsaved changes.')

            if (confirmed) {
                next()
            } else {
                next(false)
                return
            }
        }

        next()
    },
    methods: {
        saveNext() {
            this.$store.dispatch('setUnsavedData', false)

            this.$validator.validateAll().then((result) => {
                if (!result) {
                    this.saving = false
                    this.gotoFirstValidationError();
                    return;
                }

                this.save().then(() => {
                    this.$router.push({ name: this.next })
                    window.scroll(0, 0)
                });
            });
        },

        showUpdatedToast() {
            this.$toasted.show('Resource has been updated')
        }
    }
}
